<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="md"
    :modal-title="`${accessCodePaymentType === 'BASIC_CLASS' ? '기초반' : '실전반'} 학생 등록`"
    :confirm="save"
    :close="close"
    confirmButtonTitle="저장"
    :loading="loading"
    name="accessCodePaymentAuditModal"
  >
    <b-container>
      <p class="text-rose-600">현재날짜 기준 +-15일의 결제 정보가 매칭됩니다.</p>
      <b-row class="my-2">
        <b-col>
          <b-form-floating-label>
            학생 코드
          </b-form-floating-label>
          <b-form-input
            id="input-1"
            v-model="accessCode"
            type="text"
            required
          />
        </b-col>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "AccessCodePaymentAuditModal",
  components: {AdminModal},
  props: ['isOpen', 'reload', 'close', 'accessCodePaymentType'],
  data() {
    return {
      loading: false,
      accessCode: "",
    }
  },
  methods: {
    save() {
      if (this.accessCode.length === 0) {
        this.$toast.show('학생 코드를 입력하세요..',
          {
            position: "top-right",
            duration: 2000
          });
        return
      }
      

      this.loading = true
      api.accessCodePaymentAudit.save(
        {
          accessCode: this.accessCode,
          accessCodePaymentType: this.accessCodePaymentType
        },
        (response) => {
          this.reload()
          this.$toast.success('등록 완료',
            {
              position: "top-right",
              duration: 2000
            })
          this.close()
        }, (e) => {
          const message = "학생 코드를 다시 확인해주세요."
          this.loading = false
          this.$toast.error(  `등록 실패 : ${message}`,
            {
              position: "top-right",
              duration: 2000,
            });
        })
    }
  }
}
</script>

<style scoped>

</style>